import { type ModelTimestamp } from "@doitintl/models-any";
import { DateTime } from "luxon";

import { sanitizeDate } from "../utils/common";
import { TimestampFromDate } from "../utils/firebase";

export enum ColumnFilterType {
  Number = "Number",
  ModelTimestamp = "ModelTimestamp",
  DateTime = "DateTime",
}

export const firestoreTimestampFilterProps = (format: string) => ({
  type: ColumnFilterType.ModelTimestamp,
  transform: (value: string): ModelTimestamp =>
    TimestampFromDate(sanitizeDate(DateTime.fromFormat(value, format, { zone: "utc" })).toJSDate()),
  validate: (value: string): boolean => DateTime.fromFormat(value, format)?.isValid ?? false,
  toOption: (value: ModelTimestamp) => {
    if (!value) {
      return;
    }
    const strValue = DateTime.fromJSDate(value.toDate()).toFormat(format);
    return {
      value: strValue,
      label: strValue,
    };
  },
});

export const luxonDateTimeFilterProps = (format: string) => ({
  type: ColumnFilterType.DateTime,
  transform: (value: string): DateTime => sanitizeDate(DateTime.fromFormat(value, format, { zone: "utc" })),
  validate: (value: string): boolean => DateTime.fromFormat(value, format)?.isValid ?? false,
  toOption: (value: DateTime) => {
    const strValue = value.toFormat(format);
    return {
      value: strValue,
      label: strValue,
    };
  },
});
